import moment from 'moment';
import { Link } from 'react-router-dom';

const Invoice = ({ order }) => (
  <div id="invoice" className="">
    <div className=" bg-white p-9">
      <div className="flex justify-between items-center border-b pb-6 mb-6">
        <div>
          {/* Logo */}
          <Link to="/" className="flex items-center ml-4 mb-4 lg:ml-0">
            <img
              // src="/heart-svgrepo-com (1) 27-Photoroom.png"
              alt="AlgarXpress Logo"
              className="h-20 w-auto object-contain"
            />
            <div className="flex space-y-0. flex-col">
              <p className=" text-lg text-slate-800 font-bold">
                AlgarXpress
                <sup className="text-[10px] font-semibold text-slate-700 ml-0.5">™</sup>
              </p>
              <p className="font-semibold text-sm -mt-0.5 text-black">& Courier Services</p>
              <p className="font-semibold text-[12px] text-black">ISO 9001:2015 Certified Company</p>
            </div>
          </Link>
          <h2 className="text-xl font-semibold mt-4">Invoice</h2>
          <p className="text-sm text-gray-800">AWB No: {order?.awb_number}</p>
          <p className="text-sm text-gray-800">Shipment ID: {order?.order_id}</p>
          <p className="text-sm text-gray-800">Shipment No: {order?.order_number}</p>
          <p className="text-sm text-gray-800">Shipment Date: {moment(order?.createdAt).format('DD/MM/YYYY')}</p>
        </div>
        <div className="text-right">
          <h2 className="text-xl font-semibold text-green-600">PAID</h2>
          <h2 className="text-lg font-semibold text-gray-800">SD</h2>
        </div>
      </div>

      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-800">Billing Information:</h2>
        <p className="text-sm text-gray-800">{order?.deliveryAddress?.name}</p>
        <p className="text-sm text-gray-800">{order?.deliveryAddress?.address1}, {order?.deliveryAddress?.city}, {order?.deliveryAddress?.stateId?.name} - {order?.deliveryAddress?.zipCode}</p>
        <p className="text-sm text-gray-800">Mobile No: {order?.deliveryAddress?.phone}</p>
      </div>

      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-800">Shipment Information:</h2>
        <p className="text-sm text-gray-800">Fwd Destination Code: {order?.pickupAddress?.city}/SRT</p>
        <p className="text-sm text-gray-800">Weight: AlgarXpress {order?.package_weight}</p>
      </div>

      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-800">Product Details:</h2>
        <table className="w-full mt-4 text-left border-collapse">
          <thead>
            <tr className="bg-slate-200">
              <th className="border px-4 py-2 text-gray-800">AWB NO.</th>
              <th className="border px-4 py-2 text-gray-800">Item Name</th>
              <th className="border px-4 py-2 text-gray-800">Package Value</th>
              <th className="border px-4 py-2 text-gray-800">Qty.</th>
              <th className="border px-4 py-2 text-gray-800">Total Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-4 py-2 text-gray-800">{order?.awb_number}</td>
              <td className="border px-4 py-2 text-gray-800">{order?.ProductName}</td>
              <td className="border px-4 py-2 text-gray-800">₹{order?.ProductPrice}</td>
              <td className="border px-4 py-2 text-gray-800">1</td>
              <td className="border px-4 py-2 text-gray-800">₹{order?.order_amount}</td>
            </tr>
          </tbody>
        </table>
        <div className="flex justify-end mt-4">
          <div className="w-1/2 text-right">
            <p className="text-lg font-bold text-gray-800">Shipment Total: ₹{order?.order_amount}</p>
          </div>
        </div>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-800">Pickup and Return Address:</h2>
        <p className="text-sm text-gray-800">{order?.pickupAddress.name}</p>
        <p className="text-sm text-gray-800">{order?.pickupAddress.address1}, {order?.pickupAddress.city}, {order?.pickupAddress.stateId.name}, {order?.pickupAddress.zipCode}</p>
        <p className="text-sm text-gray-800">Mobile No.: {order?.pickupAddress.phone}</p>
      </div>
    </div>
  </div>


);

export default Invoice;
